import React from "react";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";

const SedesListModal = ({ sedes = [], onClose, onDeleteSede, onNewSede }) => {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      {/* Modal responsive con scroll */}
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">
                Sedes del Cliente
              </h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl leading-none"
                aria-label="Cerrar"
              >
                ✕
              </button>
            </div>

            {/* Contenido */}
            {sedes.length === 0 ? (
              <p className="text-gray-500 text-sm">
                Este cliente no tiene sedes registradas.
              </p>
            ) : (
              <ul className="space-y-2">
                {sedes.map((sede) => (
                  <li
                    key={sede._id}
                    className="border rounded-lg p-3 flex justify-between items-center"
                  >
                    <div>
                      <p className="font-medium">{sede.name}</p>
                      {sede.address && (
                        <p className="text-sm text-gray-500">{sede.address}</p>
                      )}
                    </div>

                    <button
                      onClick={() => onDeleteSede(sede._id)}
                      className="text-red-600 hover:underline text-sm"
                    >
                      Eliminar
                    </button>
                  </li>
                ))}
              </ul>
            )}

            {/* Acciones */}
            <div className="mt-6 flex flex-col-reverse sm:flex-row justify-between gap-2">
              <Button
                variant="outline"
                onClick={onClose}
                className="w-full sm:w-auto"
              >
                Cerrar
              </Button>

              <Button onClick={onNewSede} className="w-full sm:w-auto">
                + Nueva sede
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default SedesListModal;
